import * as firebase from 'firebase';

const config = {
	apiKey: "AIzaSyCCycLesKkFT4L-f4hGe7swN5ZeKJQXNko",
	authDomain: "grocery-app-1e802.firebaseapp.com",
	databaseURL: "https://grocery-app-1e802.firebaseio.com",
	projectId: "grocery-app-1e802",
	storageBucket: "",
	messagingSenderId: "622799257022"
};

const secondaryApp = firebase.initializeApp(config, "Secondary")
export { secondaryApp }



// WEBPACK FOOTER //
// ./src/baseSecondary.js